export default __webpack_public_path__ + "static/woodswap-18ef81a288964f12a7b4f39377023433.svg";